import { z } from 'zod';
import { OutdoorBarArticleCardModelSchema } from 'entities/outdoor-bar-article';
import { GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema } from '../store';

export const createOutdoorBarArticleCardsFromGetOutdoorBarArticlesByCategoryUidApiResponse = (
    (response: z.infer< typeof GetOutdoorBarArticleCardsByCategoryUidApiResponseSchema>) => (
        response.data.map(({
            slug,
            name,
            description,
            images,
            category,

        }) => OutdoorBarArticleCardModelSchema.parse({
            uid: slug,
            name,
            description,
            category: category && {
                uid: category.slug,
            },
            image: images?.[0] && {
                url: images[0].url,
            },
        }))
    )
);
